'use client';

import React, { FC } from 'react';
import { useTranslations } from 'next-intl';
import { Equipment } from 'services/equipment/types';
import { CatHeading, CatGridItem, CatCard } from 'components/blocks-components';
import styles from '../alternate-parts.module.scss';

interface AlternatePartCardProps {
  product;
  defaultUom: string;
  selectedEquipment: Equipment;
  isPartSerialCompatible: boolean;
  isCatCorp: boolean;
  isCoreDeposite: boolean;
}

const AlternatePartCardLabels: FC<AlternatePartCardProps> = ({
  product,
  defaultUom,
  selectedEquipment,
  isPartSerialCompatible,
  isCatCorp,
  isCoreDeposite
}) => {
  const { attributes = [] } = product[0] || {};
  const t = useTranslations();
  const specifications = attributes
    .filter((attribute) => attribute.uom === defaultUom)
    .slice(0, 3);
  const isEnableaddtocart = product.some((item) => item.enableAddToCart);

  return (
    <CatGridItem>
      <CatCard className={styles['cards']}>
        <section id="img" className={styles['img']}></section>
        <section
          id="alternate-part-title"
          className={`mb-2 ${styles['alternate-part-title']}`}
        ></section>
        <section
          id="check-price-link"
          className={isCatCorp ? styles['catcorp-link'] : styles['link']}
        >
          {!isCatCorp ? (
            <>
              <div
                className={
                  isCoreDeposite ? styles['discounted-price'] : styles['price']
                }
              ></div>

              {isEnableaddtocart ? (
                <div className="py-2">
                  <div style={{ height: '32px' }}> </div>
                </div>
              ) : (
                <div
                  className="py-2"
                  data-testid="component__contactDealerActions"
                ></div>
              )}
            </>
          ) : (
            <div className={`${styles['check-price-btn']} d-none my-2`}></div>
          )}
          <div
            className={`d-flex justify-content-end ${styles['alternate-icon']}`}
          ></div>
          {!isCatCorp && isEnableaddtocart ? (
            <div style={{ height: '20px' }}></div>
          ) : null}
        </section>

        {selectedEquipment && isPartSerialCompatible ? (
          <section
            id="compatibility"
            className={`d-flex align-items-center ${styles['compatibility']}`}
          >
            <CatHeading variant="label" level="h3">
              {t('COMPATIBILITY')}
            </CatHeading>
          </section>
        ) : null}
        {specifications?.map((spec, index) => {
          if (spec?.name) {
            return (
              <section
                id={`spec${index}`}
                className={`d-flex align-items-center ${styles['spec']}`}
                key={spec.name}
              >
                <CatHeading
                  variant="label"
                  level="h3"
                  className={styles['spec__heading']}
                >
                  {spec.name}
                </CatHeading>
              </section>
            );
          }
        })}
        <section
          id="desc"
          className={` d-flex align-items-center ${styles['desc']}`}
        >
          <CatHeading variant="label" level="h3">
            {t('DESCRIPTION')}
          </CatHeading>
        </section>
      </CatCard>
    </CatGridItem>
  );
};

export default AlternatePartCardLabels;
